import {Image, Pressable} from "react-native"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import ActionBone from "./action-bone.png"
import ActionBrainBreak from "./action-brain-break.png"
import ActionChallenge from "./action-challenge.png"
import React from "react"

/** @type {Record<string, object>} */
const styles = {}

/**
 * @typedef {object} RoutesUserSchoolClassesClassSpaceActionsProps
 * @property {() => void} onStartBrainBreak
 * @property {(() => void)=} onStartBrainboundBattle
 * @property {() => void} onStartChallenge
 * @property {() => void} onStartWoof
 */

/** @typedef {object} RoutesUserSchoolClassesClassSpaceActionsState */

/**
 * @extends {ShapeComponent<RoutesUserSchoolClassesClassSpaceActionsProps, RoutesUserSchoolClassesClassSpaceActionsState>}
 */
class RoutesUserSchoolClassesClassSpaceActions extends ShapeComponent {
  static propTypes = propTypesExact({
    onStartBrainBreak: PropTypes.func.isRequired,
    onStartBrainboundBattle: PropTypes.func,
    onStartChallenge: PropTypes.func.isRequired,
    onStartWoof: PropTypes.func.isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space.actions"})

    this.t = t
  }

  render() {
    const {t} = this.tt

    return (
      <View
        dataSet={this.rootViewDataSet ||= {route: "user/school-classes/class-space/actions"}}
        style={styles.rootView ||= {
          flexDirection: "row",
          justifyContent: "center"
        }}
      >
        <View
          style={styles.woofCard ||= {
            width: 320,
            padding: 40,
            backgroundColor: "#fff",
            border: "2px solid rgb(82, 83, 255)",
            borderRadius: 48,
            boxShadow: "0 10px 15px rgb(0 0 0 / 0.3)"
          }}
        >
          <Image
            source={ActionBone}
            style={styles.woofIconImage ||= {
              width: 40,
              height: 40,
              marginLeft: "auto",
              marginRight: "auto"
            }}
          />
          <Text
            style={styles.woofIconTitle ||= {
              color: "#1b1f72",
              fontFamily: "HankenGrotesk",
              fontSize: 24,
              textAlign: "center"
            }}
          >
            {t(".start_a_new")}
          </Text>
          <Text
            style={styles.woofTitle ||= {
              color: "#1b1f72",
              fontFamily: "HankenGrotesk",
              fontSize: 48,
              textAlign: "center"
            }}
          >
            {t(".woof")}
          </Text>
          <Pressable
            dataSet={this.startWoofButtonDataSet ||= {class: "start-woof-button"}}
            onPress={this.tt.onStartWoofPress}
            style={styles.woofButton ||= {
              padding: 24,
              marginTop: 27,
              backgroundColor: "#5253ff",
              borderRadius: 36
            }}
          >
            <Text
              style={styles.woofButtonText ||= {
                color: "#fff",
                fontFamily: "HankenGrotesk",
                fontSize: 24,
                textAlign: "center"
              }}
            >
              {t(".start_woof")}
            </Text>
          </Pressable>
        </View>
        <View
          style={styles.challengeWrapper ||= {
            marginHorizontal: 24
          }}
        >
          <View
            style={styles.challengeCard ||= {
              width: 320,
              padding: 40,
              backgroundColor: "#fff",
              border: "2px solid rgb(82, 83, 255)",
              borderRadius: 48,
              boxShadow: "0 10px 15px rgb(0 0 0 / 0.3)"
            }}
          >
            <Image
              source={ActionChallenge}
              style={styles.challengeIconImage ||= {
                width: 40,
                height: 40,
                marginLeft: "auto",
                marginRight: "auto"
              }}
            />
            <Text
              style={styles.challengeIconTitle ||= {
                color: "#1b1f72",
                fontFamily: "HankenGrotesk",
                fontSize: 24,
                textAlign: "center"
              }}
            >
              {t(".this_weeks")}
            </Text>
            <Text
              style={styles.challengeTitle ||= {
                color: "#1b1f72",
                fontFamily: "HankenGrotesk",
                fontSize: 48,
                textAlign: "center"
              }}
            >
              {t(".challenge")}
            </Text>
            <Pressable
              dataSet={this.startChallengeButtonDataSet ||= {class: "start-challenge-button"}}
              onPress={this.tt.onStartChallengePress}
              style={styles.challengeButton ||= {
                padding: 24,
                marginTop: 27,
                backgroundColor: "#5253ff",
                borderRadius: 36
              }}
            >
              <Text
                style={styles.challengeButtonText ||= {
                  color: "#fff",
                  fontFamily: "HankenGrotesk",
                  fontSize: 24,
                  textAlign: "center"
                }}
              >
                {t(".start_challenge")}
              </Text>
            </Pressable>
          </View>
        </View>
        <View
          style={styles.brainBreakCard ||= {
            width: 320,
            padding: 40,
            backgroundColor: "#fff",
            border: "2px solid rgb(82, 83, 255)",
            borderRadius: 48,
            boxShadow: "0 10px 15px rgb(0 0 0 / 0.3)"
          }}
        >
          <Image
            source={ActionBrainBreak}
            style={styles.brainBreakIconImage ||= {
              width: 40,
              height: 40,
              marginLeft: "auto",
              marginRight: "auto"
            }}
          />
          <Text
            style={styles.brainBreakIconTitle ||= {
              color: "#1b1f72",
              fontFamily: "HankenGrotesk",
              fontSize: 24,
              textAlign: "center"
            }}
          >
            {t(".instant")}
          </Text>
          <Text
            style={styles.brainBreakTitle ||= {
              color: "#1b1f72",
              fontFamily: "HankenGrotesk",
              fontSize: 48,
              textAlign: "center"
            }}
          >
            {t(".brain_break")}
          </Text>
          <Pressable
            dataSet={this.startBrainBreakButtonDataSet ||= {class: "start-brain-break-button"}}
            onPress={this.tt.onStartBrainBreakPress}
            style={styles.brainBreakButton ||= {
              padding: 24,
              marginTop: 27,
              backgroundColor: "#5253ff",
              borderRadius: 36
            }}
          >
            <Text
              style={styles.brainBreakButtonText ||= {
                color: "#fff",
                fontFamily: "HankenGrotesk",
                fontSize: 24,
                textAlign: "center"
              }}
            >
              {t(".start_brain_break")}
            </Text>
          </Pressable>
        </View>
        {this.p.onStartBrainboundBattle &&
          <View
            style={styles.brainboundWrapper ||= {
              marginLeft: 24
            }}
          >
            <View
              style={styles.brainboundCard ||= {
                width: 320,
                padding: 40,
                backgroundColor: "#fff",
                border: "2px solid rgb(82, 83, 255)",
                borderRadius: 48,
                boxShadow: "0 10px 15px rgb(0 0 0 / 0.3)"
              }}
              testID="class-space-brainbound-action-card"
            >
              <Image
                source={ActionChallenge}
                style={styles.brainboundIconImage ||= {
                  width: 40,
                  height: 40,
                  marginLeft: "auto",
                  marginRight: "auto"
                }}
                testID="class-space-brainbound-action-icon"
              />
              <Text
                style={styles.brainboundIconTitle ||= {
                  color: "#1b1f72",
                  fontFamily: "HankenGrotesk",
                  fontSize: 24,
                  textAlign: "center"
                }}
                testID="class-space-brainbound-action-eyebrow"
              >
                {t(".start_a_new")}
              </Text>
              <Text
                style={styles.brainboundTitle ||= {
                  color: "#1b1f72",
                  fontFamily: "HankenGrotesk",
                  fontSize: 48,
                  textAlign: "center"
                }}
                testID="class-space-brainbound-action-title"
              >
                {t(".math_battle")}
              </Text>
              <Pressable
                onPress={this.tt.onStartBrainboundBattlePress}
                style={styles.brainboundButton ||= {
                  padding: 24,
                  marginTop: 27,
                  backgroundColor: "#5253ff",
                  borderRadius: 36
                }}
                testID="class-space-start-brainbound-battle-button"
              >
                <Text
                  style={styles.brainboundButtonText ||= {
                    color: "#fff",
                    fontFamily: "HankenGrotesk",
                    fontSize: 24,
                    textAlign: "center"
                  }}
                  testID="class-space-start-brainbound-battle-button-text"
                >
                  {t(".start_battle")}
                </Text>
              </Pressable>
            </View>
          </View>
        }
      </View>
    )
  }

  onStartChallengePress = () => this.p.onStartChallenge()
  onStartWoofPress = () => this.p.onStartWoof()
  onStartBrainBreakPress = () => this.p.onStartBrainBreak()
  onStartBrainboundBattlePress = () => {
    const {onStartBrainboundBattle} = this.p

    if (!onStartBrainboundBattle) throw new Error("Brainbound battle launcher is not available")

    onStartBrainboundBattle()
  }
}

export default memo(shapeComponent(RoutesUserSchoolClassesClassSpaceActions))
